<app-view-title [showHeader]="false"></app-view-title>
@if(loading) {
<view-content [centered]="true" [fullscreen]="true">
  <app-loading-screen [centered]="true" title="{{ 'Intellitrailer.Booking.CreateBooking.SavingBookingTitle' | translate : 'Saving booking' }}" description="{{ 'Intellitrailer.Booking.CreateBooking.SavingBookingExplanation' | translate : 'Saving the booking, please wait.' }}"></app-loading-screen>
</view-content>
<view-actions>
  <button mat-raised-button (click)="back()">{{ 'Intellitrailer.Rental.DetectLock.Cancel' | translate : 'Cancel' }}</button>
</view-actions>
}

